import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as inputs from 'esri/form/elements/support/inputs';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { FaqService } from 'src/app/services/faq-services/faq.service';
import { KnowledgebaseService } from 'src/app/services/knowledgebase.service';

@Component({
  selector: 'app-knowledgebase',
  templateUrl: './knowledgebase.component.html',
  styleUrls: ['./knowledgebase.component.scss']
})
export class KnowledgebaseComponent implements OnChanges{
  @Input() subject: string;
  @Input() data:any;
  p: number = 1; // Current page
  resultsPerPage: number = 4; // Number of results per page
  totalResults: number; // Total number of results
  @Input() kbSearch:any;
  @Output() searchEvent: EventEmitter<void> = new EventEmitter<void>();
  calculateRange() {
    const start = (this.p - 1) * this.resultsPerPage + 1;
    let end = Math.min(this.p * this.resultsPerPage, this.totalResults);

    if (start === end && start === this.totalResults) {

      end = start;
    }

    return { start, end };
  }

    jsonData: any[] = [];

    dataArray:any;

    knowledgebasejsondata: string = 'assets/json/advancedsearch.json';



    onSearchInputChange(search:any)
    {
      console.log("hyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyys")
this.searchterms=search;
console
    }
    constructor(private dialogRef: MatDialogRef<KnowledgebaseComponent>, private knowledgeService:KnowledgebaseService,private knowledgeSearchService: ApiserviceService,private http:HttpClient,private faqservice:FaqService) {
      // console.log(data)
    }

    onClose(): void {
    this.dialogRef.close();
  }
    ngOnChanges(changes: SimpleChanges) {
      console.log("ngonchange")
      console.log(changes.kbSearch)

      console.log(changes.kbSearch.currentValue)
      if (changes.kbSearch && changes.kbSearch.currentValue!=undefined) {
        this.knowledgeSearchService.incidentmessage='';
          this.knowledgeSearchService.subject='';
        console.log("hyy search");
        console.log(changes.kbSearch.currentValue, 'kbs');
        this.searchterms = changes.kbSearch.currentValue;
        setTimeout(() => {
          
        this.onSearch1(this.searchterms);
        }, 200);
      }
      else if (changes.kbSearch.currentValue===undefined)
        {
          this.knowledgeSearchService.incidentmessage='';
          this.knowledgeSearchService.subject='';

          console.log("in else if")
          this.showlink=false;
          this.onSearch1('')
          // this.loadFAQs();

        }
      else
      {
        console.log("in else")
        // setTimeout(() => {
          
        // this.onSearch1('')
        // }, 200);
      }
    }

     ngAfterViewInit(){
      // console.log("helloooooo")
     }

     stripHtmlAndEntities(htmlString: string): string {
      if (!htmlString) return '';

      // Remove HTML tags
      const withoutTags = htmlString.replace(/<[^>]*>/g, '');
      const trimmedString = withoutTags.trim().replace(/^"/, '').replace(/"$/, '');
      // Remove &nbsp; entities
      const withoutEntities = trimmedString.replace(/&nbsp;/g, ' ');

      // Remove quotation marks
      const withoutQuotationMarks = withoutEntities.replace(/"/g, '');

      // Add space character
      const withSpace = withoutQuotationMarks + ' ';

      return withSpace;
  }
  showlink:boolean=false;
    ngOnInit()
    {
      console.log(this.kbSearch)
      console.log('Subject in KnowledgebaseComponent:', this.knowledgeSearchService.subject);
    //   console.log(this.data)
    // this.kbSearch=this.data;
    // this.loadFAQs();
    if(this.knowledgeSearchService.subject!=null && this.knowledgeSearchService.incidentmessage==="incident thread")
    {
      console.log("in knowledgebase")
      this.showlink=true;
      this.knowledgeSearchService.subject;
      setTimeout(() => {
        
      this.onSearch1(this.knowledgeSearchService.subject);
      }, 200);
    }
    else if(this.kbSearch || this.kbSearch=='')
    {
      this.showlink=false;
      console.log(this.kbSearch)
    // this.searchQuery = this.kbSearch;
    // console.log(this.kbSearch)
    this.onSearch1(this.kbSearch);
    }
else
      {
        console.log("in this")
        this.showlink=true;
        this.onSearch1('')
      }


      // console.log(this.dataArray);

      // console.log(this.dataArray);
      // this.loadFAQs();

    }
    datatableload:any
    datatablepagination() {
      // alert()
          $("#knowledgebasetable2_wrapper").remove();
      
          setTimeout(() => {
            ($('#knowledgebasetable2') as any).dataTable({
              "language": {
                "paginate": {
                  "previous": "",
                  "next": ""
                },
                "lengthMenu": "Records per page _MENU_",
              },
              pageLength: this.pageSize,
              // "order": [[2, "asc"]],
      
              "columnDefs": [
                { "orderable": false, "targets": 0 },
                // { "orderable": false, "targets": 2 },
                { 'orderable': false, 'targets': 5 }
              ],
      
              "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
                fixedColumns: {
                  start: 0,
                  end: 5
              },
              paging: true,        
              fixedHeader: true,
               scrollX: true,
              scrollY: 450,
              destroy:true,
              dom: 'rt',
      
              drawCallback: function (settings) {
                const api = this.api();
                const rows = api.rows({ page: 'current' }).nodes();
                let startIndex = api.page() * api.page.len() + 1;
      
                $(rows).each(function (index) {
                  $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
                  startIndex++;
                });
              },
            });
          }, 200);
      
          this.datatableload=true
          
        }

    paginateItems(items: any[], page: number, itemsPerPage: number): any[] {
      const startIndex = (page - 1) * itemsPerPage;
      return items.slice(startIndex, startIndex + itemsPerPage);
    }

    itemsPerPage = 2;
    currentPage:number=0;



    getPaginatedItems() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.jsonData.slice(startIndex, startIndex + this.itemsPerPage);
    }

    nextPage() {
      if (this.currentPage < Math.ceil(this.jsonData.length / this.itemsPerPage)) {
        this.currentPage++;
      }
    }

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }

    filterDataone(query: string): any[] {
      // console.log(dataArray);
      console.log("query is " + query);

      query = query.toLowerCase();

      return this.dataArray.filter((department: any) => {
        return department.categories.some((category: any) => {
          return category.items.some((item: any) => {
            return (
              item.title.toLowerCase().includes(query) ||
              item.question.toLowerCase().includes(query) ||
              item.answer.toLowerCase().includes(query)
            );
          });
        });
      });
    }

    keyy:any;
    querydata:any;

    separateItems(data:any) {
      const separatedItems = [];

      for (const department of data) {
        for (const category of department.categories) {
          console.log(category)
          for (const item of category.items) {
            separatedItems.push({
              department: department.department,
              category: category.name,
              title: item.title,
              question: item.question,
              answer: item.answer,
              published: item.published,
              updated: item.updated,
              phone: item.phone,
              id:item.id,

              // Add more fields as needed
            });
          }
        }
      }

      return separatedItems;
    }


    separatedData:any;


    // Modify the filterData function to work with the separated data
    // filterData(query: string, selectedDepartment: string, selectedCategory: string) {

    //   let querydata = [...this.separatedData]; // Use the separated data

    //   if (query) {
    //     query = query.toLowerCase();
    //     querydata = querydata.filter((item) => (
    //       item.title.toLowerCase().includes(query) ||
    //       item.question.toLowerCase().includes(query) ||
    //       item.answer.toLowerCase().includes(query)
    //     ));
    //   }

    //   if (selectedDepartment) {
    //     selectedDepartment = selectedDepartment.toLowerCase();
    //     querydata = querydata.filter((item) => (
    //       item.department.toLowerCase().includes(selectedDepartment)
    //     ));
    //   }

    //   if (selectedCategory) {
    //     console.log(selectedCategory)
    //     selectedCategory = selectedCategory.toLowerCase();
    //     querydata = querydata.filter((item) => (
    //       item.category.toLowerCase().includes(selectedCategory)
    //     ));
    //   }


    //   return querydata;
    // }
    // filterData(query: string, selectedDepartment: string, selectedCategory: string): any[] {
    //   let querydata = [...this.separatedData];

    //   const uniqueTitles = new Set();

    //   if (query) {
    //     querydata = querydata.filter((item) => {
    //       const compositeKey = `${item.title.toLowerCase()}|${item.question.toLowerCase()}|${item.answer.toLowerCase()}`;

    //       if (!uniqueTitles.has(compositeKey)) {
    //         uniqueTitles.add(compositeKey);
    //         const matchesQuery = !query || compositeKey.includes(query.toLowerCase());
    //         const matchesDepartment = !selectedDepartment || item.department.toLowerCase().includes(selectedDepartment.toLowerCase());
    //         const matchesCategory = !selectedCategory || item.category.toLowerCase().includes(selectedCategory.toLowerCase());

    //         return matchesQuery && matchesDepartment && matchesCategory;

    //       }

    //       return false;
    //     });
    //   }

    //   if (selectedDepartment) {
    //     selectedDepartment = selectedDepartment.toLowerCase();
    //     querydata = querydata.filter((item) => (
    //       item.department.toLowerCase().includes(selectedDepartment)
    //     ));
    //   }

    //   if (selectedCategory) {
    //     selectedCategory = selectedCategory.toLowerCase();
    //     querydata = querydata.filter((item) => (
    //       item.category.toLowerCase().includes(selectedCategory)
    //     ));
    //   }

    //   return querydata;
    // }

    filterData(query: string, selectedDepartment: string, selectedCategory: string): any[] {

      let querydata = [...this.separatedData];
      this.p=1;
      const uniqueTitles = new Set();

      querydata = querydata.filter((item) => {
        const compositeKey = `${item.title.toLowerCase()}|${item.question.toLowerCase()}|${item.answer.toLowerCase()}`;

        if ((query || query=='') && (!selectedDepartment || !selectedCategory)) {
          // Apply uniqueTitles filter only when there is a query and either department or category is not selected
          if (!uniqueTitles.has(compositeKey)) {
            uniqueTitles.add(compositeKey);
            const matchesQuery = !query || compositeKey.includes(query.toLowerCase());

            return matchesQuery;
          }
        } else {
          // No query or both department and category are selected, no need for uniqueTitles filter

          const matchesQuery = !query || compositeKey.includes(query.toLowerCase());
          const matchesDepartment = !selectedDepartment || item.department.toLowerCase().includes(selectedDepartment.toLowerCase());
          const matchesCategory = !selectedCategory || item.category.toLowerCase().includes(selectedCategory.toLowerCase());

          return matchesQuery && matchesDepartment && matchesCategory;
        }

        return false;
      });

      if (selectedDepartment) {
        selectedDepartment = selectedDepartment.toLowerCase();
        querydata = querydata.filter((item) => (
          item.department.toLowerCase().includes(selectedDepartment)
        ));
      }

      if (selectedCategory) {
        console.log(selectedCategory)
        selectedCategory = selectedCategory.toLowerCase();
        querydata = querydata.filter((item) => (
          item.category.toLowerCase().includes(selectedCategory)
        ));
      }

      return querydata;
    }
    displayfilters:boolean=false;
    filteredData: any[] = [];
    selectedOption:any;
    categoryidselected:any;
    searchterms:any;
    selectedDepartment: any;
    selectedCategory: any;
    searchQuery: string = '';
  advancesearchpopup:boolean=false;
    categories:any;

    departments = [];
    updateCategories() {

      this.selectedCategory='';// Find the selected department based on its name
      const selectedDept = this.dataArray.find((dept:any) => dept.department === this.selectedDepartment);
  console.log(selectedDept)
      if (selectedDept) {
        this.categories = selectedDept.categories;
      } else {
        this.categories = []; // Clear categories if no department is selected
      }
    }
  // onSearch(): void {

  //   this.displayfilters=true;
  //   this.knowledgeSearchService.updateSearchQuery(this.searchterms, this.selectedDepartment, this.selectedCategory);

  // }
  catid:any;
  filtereddata:any;
  onSearch(): void {

    this.knowledgeSearchService.updateSearchQuery(this.searchterms, this.selectedDepartment, this.selectedCategory);
    // console.log(this.searchterms, this.selectedDepartment, this.selectedCategory,'1111')
    // this.searchEvent.emit();
    // this.knowledgeService.triggerSearchEvent();
  }

  advsearchpopup()
  {
    this.advancesearchpopup=true;
  }

  closepopup()
  {
    this.advancesearchpopup=false;
  }

  removecategoryfilter()
  {
    this.selectedCategory='';
    this.onSearch();
  }

  removeproductfilter()
  {
    this.selectedDepartment='';
    this.onSearch();
  }
    selectedItemId: any = null;

    showSeparatedData: boolean = false;
    selectedData: any = null;
    detailsfaq:any;
    Messagearray: any[] = [];
emailmessagearray: number[] = [];

emailmessage(data: any) {
      console.log(data);

      // Check if the data already exists in Messagearray
      const isDuplicate = this.Messagearray.some(item => item.id === data.id);
      if (!isDuplicate) {
          // Push the data into the array
          this.Messagearray.push(data);
           this.emailmessagearray.push(data.id);
          console.log(this.Messagearray);

          this.knowledgeSearchService.message = this.Messagearray;
          // this.knowledgeSearchService.link = null;
      } else {
          console.log("Duplicate data detected, not pushing into Messagearray.");
      }
  }

  emaillinkarray: any[] = [];


  emaillink(id: any) {
      console.log(id);

      // Check if the id already exists in emaillinkarray
      const isDuplicate = this.emaillinkarray.includes(id);
      if (!isDuplicate) {
          // Push the id into the array
          this.emaillinkarray.push(id);
          this.knowledgeSearchService.link = this.emaillinkarray;
      } else {
          console.log("Duplicate id detected, not pushing into emaillinkarray.");
      }

      
  }

    // Function to display separatedData based on ID
    displaySeparatedData(itemId: any) {
      this.showSeparatedData=true;
            this.knowledgeSearchService.getallanswers(itemId).subscribe((data:any)=>
      {
  console.log(data)
  this.detailsfaq=data;
  console.log(this.detailsfaq)
      })
      // this.showSeparatedData=true;
      // this.selectedItemId = itemId;
      // const selectedItem = this.separatedData.find(item => item.id === itemId);
      // this.selectedData = selectedItem ? selectedItem : null;
      // this.showSeparatedData = true;

      // console.log(this.selectedItemId)
    }
    stripQuotes(str: string): string {
      if (!str) return ''; // Return empty string if str is falsy
      return str.slice(1, -1); // Extract substring without first and last characters
    }
    showJsonData() {
      this.showSeparatedData = false; // Set flag to show jsonData
    }
    searchPerformed: boolean = false;
    filteredResults: any[] = [];
  // keyword:any;
  initialPageResetDone= "search";
    onSearch1(query: string,resetPage: boolean = true) {
      console.log(query)
        this.searchPerformed = true; // Set the flag to true to indicate that a search has been performed
        const searchResults: any[] = [];
        this.searchterms = query;
        if (resetPage) {
          this.currentPage = 0; // Reset the current page to 0 only if it's a new search
      }

        console.log(this.pageSize)
        console.log(this.initialPageResetDone)
        // this.initialPageResetDone="search";
        if(this.initialPageResetDone=="search"){
        if(this.currentPage>0)
        {
          this.currentPage=0;
        }
      }
        console.log(this.currentPage);
console.log(query)
console.log(this.pageSize)
console.log(this.kbSearch)
console.log(this.knowledgeSearchService.incidentmessage)
console.log(this.data)
if(this.kbSearch || this.kbSearch==''||this.data==='script')
{
  this.showlink=false;
  this.datatableload=false
  console.log("in kbsearch",this.kbSearch)
  this.faqservice.search(query,this.currentPage,this.pageSize).subscribe((data:any)=>
  {
    console.log(data);
    // this.filteredResults=data;
    this.allfaq=data.answerlist;
    this.totalpagesize=data.size;

    this.datatablepagination()

  })
}

else if(this.knowledgeSearchService.incidentmessage==="incident thread"){
  console.log("in kbsearch",this.kbSearch)
  console.log(query,this.currentPage,this.pageSize)
  this.datatableload=false
  this.knowledgeSearchService.getallcustomerfaq(query,this.currentPage,this.pageSize).subscribe((data:any)=>
  {
    console.log(data);
    // this.filteredResults=data;
    this.allfaq=data.answerlist;
    this.totalpagesize=data.size;


    this.datatablepagination()
  })
}

  this.initialPageResetDone="search";
  console.log(this.initialPageResetDone)

  console.log(this.initialPageResetDone)
    }
  keyword:any;
  recentsearch:any;
  // getallrecentsearches(){
  //   this.knowledgeSearchService.getrecentsearch().subscribe((data:any)=>
  //   {
  //     console.log(data)
  //     this.recentsearch=data;

  //   })
  // }
  page:any;
  size=['10','25','50','100'];
  // currentPage: number = 0;
  pageSize: number = 10;
  totalpagesize:any;
  totalItems: number = 50;
  answerlistlength:any;
  allfaq:any=[];
  loadFAQs(): void {
    console.log(this.currentPage)
    console.log(this.pageSize)
    this.faqservice.allArticles(this.currentPage,this.pageSize)
      .subscribe((data: any) => {
        console.log(data);
        this.allfaq = data.answerlist;
  this.answerlistlength=data.answerlist.length;
        this.totalpagesize=data.size;   ;
        console.log(this.allfaq);
      });
  }
  onpagesize(pagesize:any)
  {
    console.log(pagesize)
    this.pageSize=pagesize;
    if(this.searchterms=='')
    {
      console.log("search query in loadfaq",this.searchterms)

      // this.goToPage(this.currentPage)
      this.getPageNumbers()
      this.loadFAQs();

      console.log(this.currentPage)
      console.log(this.pageCount)
      // this.getPageNumbers();
    }

    console.log(this.searchterms)
    if(this.searchterms!='')
    {
      console.log("search query in onsearch",this.searchterms)
      this.getPageNumbers()
  this.onSearch1(this.searchterms,false)
    }
  }
  nextPage2(): void {
    this.currentPage++;

    if(this.searchterms=='')
    {
      console.log("search query in loadfaq",this.searchterms)
      this.loadFAQs();
    }

    console.log(this.searchterms)
    if(this.searchterms!='')
    {
      this.initialPageResetDone="next";
      console.log("search query in onsearch",this.searchterms)
  this.onSearch1(this.searchterms,false)
    }
  }

  previousPage2(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      if(this.searchterms=='')
      {
        console.log("search query in loadfaq",this.searchterms)
        this.loadFAQs();
      }
      if(this.searchterms!='')
      {
        console.log("search query in onsearch",this.searchterms)
    this.onSearch1(this.searchterms,false)
      }
    }
  }
  pageCount:any;

  getPageNumbers(): number[] {

    if(this.searchterms!='')
    {
      // console.log("hellooooooo")
      this.initialPageResetDone="next";

    }
    // this.loadFAQs();
    const pageCount = Math.ceil(this.totalpagesize / this.pageSize);
    this.pageCount = pageCount;
    const pageNumbers = [];
    let currentPageIndex = this.currentPage;

    // Show first 5 page numbers initially
    let startPage = Math.max(0, currentPageIndex - 2);
    const endPage = Math.min(pageCount - 1, startPage + 4);
  // console.log("startpage",startPage)
  // console.log("endpage",endPage)
  // console.log("pageCount",pageCount)
  // console.log("currentPageIndex",currentPageIndex)
    // Adjust startPage and endPage when total items are less than expected end page
    if (endPage - startPage < 4 && endPage < pageCount - 1) {
      startPage = Math.max(0, endPage - 4);
    }
  if(this.currentPage>endPage)
  {
    this.currentPage=endPage;
    console.log(this.currentPage)
    // this.loadFAQs()

  }
//   if(this.searchterms!='')
//   {
//     this.initialPageResetDone="next";
//     console.log("search query in onsearch",this.searchterms)
// // this.onSearch1(this.searchterms)
//   }
    for (let i = startPage; i <= endPage; i++) {
  // console.log(pageNumbers)
      pageNumbers.push(i);
    }

    return pageNumbers;
  }


  goToPage(pageNumber: number): void {
    this.currentPage = pageNumber;
    console.log(this.currentPage)
    if(this.searchterms=='')
    {
      console.log("search query in loadfaq",this.searchterms)
      this.loadFAQs();
    }

    console.log(this.searchterms)
    if(this.searchterms!='')
    {
      // this.initialPageResetDone="next";
      console.log("search query in onsearch",this.searchterms)
  this.onSearch1(this.searchterms,false)
    }
  }
  getRecordsRange(): string {
    const startRecord = this.currentPage * this.pageSize + 1;
    // console.log(startRecord)
    const endRecord = Math.min((this.currentPage + 1) * this.pageSize, this.totalpagesize);
    // console.log(endRecord)

    return `${startRecord} - ${endRecord} of ${this.totalpagesize}`;
  }



}
